<template>
  <li>
    <button @click="module.assetCount > 0 ? openDialog() : null"
      class="w-full h-full grid items-start text-gray-900 text-left shadow-md rounded-md bg-white py-6 px-8 transition-shadow duration-200 hover:shadow-lg"
      :class="{ 'cursor-not-allowed opacity-50': module.assetCount < 1 }">
      <h3 class="text-teal-600 text-xl mb-0">{{ module.title }}</h3>

      <div class="flex items-center justify-between mt-4">
        <span class="flex items-center gap-2">
          <SvgIcon name="file-fill" classes="text-teal-600 size-5" /> <span>{{ module.assetCount }} Assets
            <span v-if="moduleSelectedFileCount > 0">({{ moduleSelectedFileCount }} selected)</span></span>
        </span>
        <span v-if="module.parent"
          class="uppercase font-semibold text-base bg-slate-200 px-2 py-1 text-slate-500 rounded">{{ module.parent.title }}</span>
      </div>
    </button>

    <dialog ref="dialogRef" @click="closeDialogOnBackground"
      class="w-full max-w-11/12 mx-auto rounded-lg h-[80vh] xl:max-w-6xl">
      <div class="grid">
        <header class="flex items-center gap-x-4 justify-between p-4">
          <h2 class="text-teal-600 text-3xl mb-0">{{ module.title }}</h2>
          <span class="flex items-center gap-2 mr-auto">
            <SvgIcon name="file-fill" classes="text-teal-600 size-5" /> <span>{{ module.assetCount }}</span>
          </span>

          <button v-if="selectedFileCount" @click.prevent="downloadAndClose" class="btn bg-teal-700">
            <span v-if="!downloading">Download All ({{ selectedFileCount }} selected)</span>
            <vue-simple-spinner v-else size="small" line-bg-color="#fff" line-fg-color="#5ca0ea" />
          </button>
          <button type="button" @click="closeDialog" class="">Close</button>
        </header>

        <div class="relative overflow-scroll">
          <asset-browser-files @updateFileCount="updateFileCount" :module="module"
            :selectedFileCount="selectedFileCount" />
        </div>
      </div>
    </dialog>
  </li>
</template>

<script>
import AssetBrowserFiles from './AssetBrowserFiles.vue'
import SvgIcon from './SvgIcon.vue'

export default {
  name: 'assetBrowserModule',

  props: {
    module: {
      type: Object,
      required: true
    },
    selectedFileCount: {
      type: Number,
      required: false,
      default: 0
    },
    downloadFiles: {
      type: Function,
      required: true
    },
    downloading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      moduleSelectedFileCount: 0
    }
  },

  components: {
    AssetBrowserFiles,
    SvgIcon
  },

  watch: {
    selectedFileCount(newCount) {
      if (newCount === 0) this.moduleSelectedFileCount = 0
    }
  },

  methods: {
    updateFileCount(count) {
      this.moduleSelectedFileCount = this.moduleSelectedFileCount + count
    },

    openDialog() {
      this.$refs.dialogRef.showModal()
    },

    closeDialog() {
      this.$refs.dialogRef.close()
    },

    closeDialogOnBackground(event) {
      const dialog = this.$refs.dialogRef;
      if (!dialog) return;

      const rect = dialog.getBoundingClientRect();
      const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
      if (!isInDialog && event.target.tagName === 'DIALOG') {
        dialog.close();
      }
    },

    downloadAndClose() {
      try {
        if (typeof this.downloadFiles === 'function') {
          this.downloadFiles()
        }
      } catch (e) {
        // ignore errors from parent download
      }

      // Close the dialog if open
      const dialog = this.$refs.dialogRef
      if (dialog && dialog.open) {
        dialog.close()
      }
    }
  }
}
</script>

<style scoped>
dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
